import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section";
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click";
import MainMenu_Tools from "../../../../layout/menu/sections/tools/menu-tools";
import {getNavigationPosition} from "../../navigation/functions/get-navigation-position";
import NavigationMenu_ToolsContent from "../../../../layout/menu/sections/tools/menu-content";


export class SpaceTools extends SpaceProto {



    constructor() {
        super(NavigationSectionType.TOOLS)

        this.title      = "Tools"
        this.svgIcon    = "isvg-tools"

        this.defaultPosition    = NavigationButtonPosition.MORE
    }

    onClick = () => {
        navigationStructureOnClick(this.navigation)
    }

    get navigationStructureConfig() {

        // carefull we must have only 2 options !!!
        // const position = _.get(gd.user.settings.navigation.buttonPositions, this.id) === NavigationButtonPosition.TOP ? NavigationButtonPosition.TOP : NavigationButtonPosition.MORE

        // const position = NavigationButtonPosition.STATIC

        // const position = getNavigationPosition(NavigationSectionType.TOOLS) //NavigationButtonPosition.STATIC

        return {
            id              : this.id,
            name            : "Tools",
            icon            : "i5-nav-tools",
            iconActive      : "i5-nav-tools-solid",
            hint            : "Tools",
            type            : NavigationSectionType.TOOLS,
            renderComponent : Navigation_ButtonGenericDeprecated,
            menuComponent   : MainMenu_Tools,
            menuContent     : NavigationMenu_ToolsContent,
            onClick         : this.onClick,
            position        : this.position,
        }

    }



}
